import { isUploadPurpose, uploadPolicies, type UploadPurpose } from "@car/api/storage-config";
import type { UploadPolicy } from "@car/ui/components/file-upload";
import type { UploadTransport } from "@car/ui/lib/upload";
import { env } from "@car/env/web";

import { client } from "@/utils/orpc";

// The site's uploads (customer panel Document Files): the shared uploader
// (@car/ui/components/file-upload) talks to the API's storage procedures; files go
// from the browser straight to S3.

export const uploadTransport: UploadTransport = {
  create: ({ purpose, ...file }) => {
    if (!isUploadPurpose(purpose)) throw new Error(`unknown upload purpose: ${purpose}`);
    return client.storage.createUpload({ purpose, ...file });
  },
  signParts: (input) => client.storage.signParts(input),
  complete: (input) => client.storage.completeUpload(input),
  abort: (input) => client.storage.abortUpload(input),
};

/** Types, size cap and wording of one purpose, as the uploader components take them */
export const uploadPolicy = (purpose: UploadPurpose): UploadPolicy => ({
  purpose,
  types: uploadPolicies[purpose].types,
  maxBytes: uploadPolicies[purpose].maxBytes,
  typesLabel: uploadPolicies[purpose].typesLabel,
});

/** The API's image optimizer, for <Image> (@car/ui/components/image) */
export const imageConfig = { path: `${env.VITE_SERVER_URL.replace(/\/$/, "")}/image` };

/** Where every optimized photo is fetched from; the document preconnects to it */
export const imageOrigin = new URL(env.VITE_SERVER_URL).origin;
